/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { CompanyTemperature } from "./CompanyTemperature";
import {
  CompanyTemperatureFromJSON,
  CompanyTemperatureFromJSONTyped,
  CompanyTemperatureToJSON,
  CompanyTemperatureToJSONTyped,
} from "./CompanyTemperature";
import type { ControlsLtlFreight } from "./ControlsLtlFreight";
import {
  ControlsLtlFreightFromJSON,
  ControlsLtlFreightFromJSONTyped,
  ControlsLtlFreightToJSON,
  ControlsLtlFreightToJSONTyped,
} from "./ControlsLtlFreight";

/**
 *
 * @export
 * @interface LinkedCompany
 */
export interface LinkedCompany {
  /**
   *
   * @type {string}
   * @memberof LinkedCompany
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof LinkedCompany
   */
  companyName: string;
  /**
   *
   * @type {ControlsLtlFreight}
   * @memberof LinkedCompany
   */
  controlsLtlFreight?: ControlsLtlFreight | null;
  /**
   *
   * @type {CompanyTemperature}
   * @memberof LinkedCompany
   */
  temperature?: CompanyTemperature | null;
  /**
   *
   * @type {string}
   * @memberof LinkedCompany
   */
  shipmentFrequency?: string | null;
  /**
   *
   * @type {string}
   * @memberof LinkedCompany
   */
  shipmentFrequencyNote?: string | null;
  /**
   *
   * @type {CurrencyCode}
   * @memberof LinkedCompany
   */
  currency?: CurrencyCode | null;
  /**
   *
   * @type {string}
   * @memberof LinkedCompany
   */
  networkId?: string | null;
}

/**
 * Check if a given object implements the LinkedCompany interface.
 */
export function instanceOfLinkedCompany(value: object): value is LinkedCompany {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  return true;
}

export function LinkedCompanyFromJSON(json: any): LinkedCompany {
  return LinkedCompanyFromJSONTyped(json, false);
}

export function LinkedCompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LinkedCompany {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    companyName: json["companyName"],
    controlsLtlFreight:
      json["controlsLtlFreight"] == null
        ? undefined
        : ControlsLtlFreightFromJSON(json["controlsLtlFreight"]),
    temperature:
      json["temperature"] == null
        ? undefined
        : CompanyTemperatureFromJSON(json["temperature"]),
    shipmentFrequency:
      json["shipmentFrequency"] == null ? undefined : json["shipmentFrequency"],
    shipmentFrequencyNote:
      json["shipmentFrequencyNote"] == null
        ? undefined
        : json["shipmentFrequencyNote"],
    currency:
      json["currency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["currency"]),
    networkId: json["networkId"] == null ? undefined : json["networkId"],
  };
}

export function LinkedCompanyToJSON(json: any): LinkedCompany {
  return LinkedCompanyToJSONTyped(json, false);
}

export function LinkedCompanyToJSONTyped(
  value?: LinkedCompany | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    companyName: value["companyName"],
    controlsLtlFreight: ControlsLtlFreightToJSON(value["controlsLtlFreight"]),
    temperature: CompanyTemperatureToJSON(value["temperature"]),
    shipmentFrequency: value["shipmentFrequency"],
    shipmentFrequencyNote: value["shipmentFrequencyNote"],
    currency: CurrencyCodeToJSON(value["currency"]),
    networkId: value["networkId"],
  };
}
